import React, { useState } from 'react';
import logo from '../assets/logo.png';

// Company logo image. Falls back to a simple text mark if the image cannot load.
export default function Logo({ light = false }) {
  const [failed, setFailed] = useState(false);

  if (failed) {
    return (
      <span className={`logo logo--text ${light ? 'logo--light' : ''}`}>
        <strong>Sheba Digital</strong>
        <small>Limited &middot; Sheba Group</small>
      </span>
    );
  }

  return (
    <span className="logo">
      <img src={logo} alt="Sheba Digital Limited" onError={() => setFailed(true)} />
    </span>
  );
}
